import { render, staticRenderFns } from "./MocktestsCreate.vue?vue&type=template&id=29fa237a&"
import script from "./MocktestsCreate.vue?vue&type=script&lang=js&"
export * from "./MocktestsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports